/* eslint-disable quotes */
import { Translation } from '../../../settings/i18n/languages';

export const en: Translation = {
  //ogólne
  YES: 'Yes',
  NO: 'No',
  ID: 'Id',
  LP: 'No.',
  OF: 'of ',
  TO: 'to',
  BY: 'by',
  EMPTY_IS_NOT_ALLOWED: 'Field is required',
  NATURAL_NUMBERS_ALLOWED: 'Natural numbers allowed',
  ARE_YOU_SURE: 'Are you sure?',
  SAVE_CHANGES: 'Save Changes',
  CONFIRM: 'Confirm',
  CANCEL: 'Cancel',
  CLOSE: 'Close',
  AND: 'and',
  ON_BEHALF_OF: 'on behalf of',
  NO_DATA: 'No data',
  NO_MARK: 'No mark',
  START_TYPING: 'Start typing to search for',
  START_TYPING_SHORT: 'Search',
  EXPAND: 'Expand',
  COLLAPSE: 'Collapse',
  BUTTON_NEXT: 'Next',
  BUTTON_PREV: 'Previous',
  SEMESTRAKADEMICKI_ZIMA: 'Winter',
  SEMESTRAKADEMICKI_LATO: 'Summer',
  CLOSE_TAB: 'Close tab',
  CLICK_HERE: 'click here',
  PRINT_STUDENTS_LIST: 'Print a student list',
  PRINT_STUDENTS_LIST_WITH_MARKS: 'Print a mark list',
  PRINT_ATTENDANCE_LIST: 'Print an attendance list',
  GET_ALL_RECORDS: 'Get all records',
  GET_STUDENTS_LIST_EXCEL: 'Export to .csv file',

  EXPIRED_REFRESH_TOKEN_ERROR_TITLE: 'Session expired',
  EXPIRED_REFRESH_TOKEN_REDIRECT_TO_CAS: 'You would be redirected to authentication page',

  TEACHER_SESSION_ACTIVE_CANNOT_LOGIN: 'No access to resource',
  COLUMNS_FILTER_MODAL_SELECT_MIN_ONE_ERROR: 'Choose minimum one column for every list',
  UNKNOWED_ERROR_TITLE: 'Uknkown error occured',
  UNKNOWED_ERROR_BODY: 'Try again later',
  WRONG_CODE_TITLE: 'Invalid code!',
  WRONG_EMAIL_CODE_BODY: 'The email code you entered is invalid! Try again',
  WRONG_SMS_CODE_BODY: 'The sms code you entered is invalid! Try again',

  ERROR_PROTOCOL_GENERATION_NO_SUM_CONTROL_TITLE: 'Error writing protocol to database',
  ERROR_PROTOCOL_GENERATION_NO_SUM_CONTROL_BODY:
    'There was an error writing the protocol to the database due to a missing checksum, please contact your system administrator',

  CHANGE_LANGUAGE: 'Change Language',
  WRONG_DATA_FORMAT_INFO: 'Invalid data format',
  NO_GRADES_IMPORTANCE: 'Missing grades importance, adding marks is not possible',
  NO_GRADES_IMPORTANCE_TITLE: 'No grade weights. Some partial marks cannot be given or final mark would not be calculated.',
  FORMA_NO_GRADES_IMPORTANCE: 'For the following form mark cannot be given. Grade weight is missing.',
  NO_FORMY_ZAJEC_TITLE: 'There are no classess forms defined for this subject.',
  NO_FORMY_ZAJEC_DESCRIPTION: "Please contact card manager or dean's office to define classes forms.",
  NO_RIGHTS_TO_GIVE_MARK: 'You do not have rights to give this mark.',
  NO_PARTIAL_MARKS: 'No classess forms defined',
  ROLE_SUPERTEACHER: 'Superteacher',
  ROLE_SUBJECT_MANAGER: 'Subject Manager',
  ROLE_INSTRUCTOR: 'Instructor',
  MY_SUBJECTS_TAB_TITLE: 'My subjects',
  STUDENTS_TAB_TITLE: 'Students',
  SUBJECT_CARDS_TAB_TITLE: 'Subject cards',
  STUDENT_FINDER_TAB_TITLE: 'Students',
  TABLE_HEADER_TOTAL: 'Total',
  TABLE_HEADER_DISPLAYED: 'Displayed',
  TABLE_HEADER_SELECTED: 'Selected',
  TABLE_HEADER_REMAINDER: 'Remainder',
  FILTER_ADD_FILTER: 'Add filter',
  FILTER_SEMESTER: 'Semester',
  FILTER_YEAR: 'Year',
  FILTER_SUBJECT: 'Subject',
  FILTER_NO_FITLERS: 'No filters available',
  COLUMNS_FILTER_MAIN_TITLE: 'General data',
  COLUMNS_FILTER_MAIN_SUBTITLE: 'Data displayed in table headers',
  COLUMNS_FILTER_DETAILS_TITLE: 'Details data',
  COLUMNS_FILTER_DETAILS_SUBTITLE: 'Data displayed after choosing list element',
  BUTTON_GENERATE_PROTOCOL: 'Generate Protocol',
  BUTTON_CHANGE_LOG: 'Change Log',
  BUTTON_SIGN_MARKS: 'Sign Marks',
  BUTTON_GO_TO_STUDENT_TAB: 'Show student',
  BUTTON_COPY_FINAL_MARKS: 'Give final marks',
  BUTTON_EDIT_FINAL_MARK: 'Edit Final Mark',
  USER_PANEL_SETTINGS: 'Settings',
  USER_PANEL_HELP: 'Help',
  USER_PANEL_LOGOUT: 'Logout',
  USER_PANEL_LOGIN: 'Login',
  SUPERTEACHER_PANEL_NAME: 'SuperTeacher Panel',
  SUPERTEACHER_PANEL_LOGOUT_FROM: 'Come back to main account',
  SUPERTEACHER_PANEL_LOGIN_AS: 'Login As...',
  IN_PROGRESS_GENERATE_PROTOCOL: 'During generation..',

  //przydział
  PRZYDZIAL_LIST_PROWADZACYPID: 'Subject Host ID',
  PRZYDZIAL_LIST_ROKAKADEMICKI: 'Year',
  PRZYDZIAL_LIST_SEMESTRAKADEMICKI: 'Semester',
  PRZYDZIAL_LIST_PRZEDMIOTFORMAKOD: 'Classes form',
  PRZYDZIAL_LIST_PRZEDMIOTFORMANAZWA: 'Subject name',
  PRZYDZIAL_LIST_PRZEDMIOTFORMAKODLISTA: 'Subject code',
  PRZYDZIAL_LIST_PROWADZACYPIDLISTA: 'Subject manager',
  PRZYDZIAL_LIST_PROWADZACYNAZWALISTA: 'Subject host',
  PRZYDZIAL_LIST_PRZEDMIOTFORMANAZWALISTA: 'Subject forms',

  PRZYDZIAL_PRZEDMIOTID: 'Subject Id',
  PRZYDZIAL_POWADZACYPID: 'Host Id',
  PRZYDZIAL_PRZEDMIOTKOD: 'Subject code',
  PRZYDZIAL_PRZEDMIOTFORMAKOD: 'Subject Form Code',
  PRZYDZIAL_PRZEDMIOTFORMANAZWA: 'Meeting Form',
  PRZYDZIAL_PRZEDMIOTFORMAKODLISTA: 'Meeting Form IDs List',
  PRZYDZIAL_PRZEDMIOTFORMANAZWALISTA: 'Meeting Form List',
  PRZYDZIAL_PROWADZACYPIDLISTA: 'Subject Host IDs List',
  PRZYDZIAL_PROWADZACYNAZWALISTA: 'Subject Host List',
  PRZYDZIAL_WAGAFORMYZAJEC: 'Grade importance',
  PRZYDZIAL_WAGIFORMYZAJEC: 'Grades importance',
  PRZYDZIAL_ROKAKADEMICKI: 'Year',
  PRZYDZIAL_LICZBASTUDENTOW: 'Student amount',
  PRZYDZIAL_WYDZIALZLECAJACYNAZWA: 'Commissioning Faculty',
  PRZYDZIAL_PROWADZACYPID: 'Subject Host ID',
  PRZYDZIAL_PRZEDMIOTNAZWA: 'Subject Name',
  PRZYDZIAL_SEMESTRAKADEMICKI: 'Semester',
  PRZYDZIAL_WYDZIALZLECAJACYKOD: 'Commissioning Faculty ID',
  PRZYDZIAL_OCENAKONCOWA: 'Final mark',
  KIEROWNICY_KARTY_LISTA: 'Card manager',
  PRZYDZIAL_INFO_YOUAREMANAGER: 'You are subject manager',
  PRZYDZIAL_BRAK_PRZYDZIALU_SID_TITLE: 'There is no assignation for this subject.',
  PRZYDZIAL_BRAK_PRZYDZIALU_SID_DESCRIPTION: 'Create assignation to be able to give marks.',
  CZY_PROTOKOL_AKTUALNY: 'Up to date protocol',

  // Studenci
  STUDENT_PRACOWNIKID: 'User ID',
  STUDENT_SEMESTRAKADEMICKI: 'Semester',
  STUDENT_ROKAKADEMICKI: 'Year',
  STUDENT_STUDENTID: 'Student ID',
  STUDENT_STUDENTALBUM: 'Register No.',
  STUDENT_STUDENTIMIE: 'First Name',
  STUDENT_STUDENTNAZWISKO: 'Surname',
  STUDENT_STUDENTZDJECIE: 'Image',
  STUDENT_STUDENTWYDZIAL: 'Student Faculty',
  STUDENT_KIERUNEKID: 'Field of Study ID',
  STUDENT_KARTAOCENID: 'Evaluation Card ID',
  STUDENT_KARTATYP: 'Evaluation Card Type',
  STUDENT_KIERUNEKNAZWA: 'Field of Study',
  STUDENT_RODZAJSTUDIOW: 'Study type',
  STUDENT_SEMESTRSTUDIOW: 'Study Semester',
  STUDENT_OCENAKONCOWA: 'Final mark',
  STUDENT_OCENAWYLICZONA: 'Calculated Mark',
  STUDENT_CZYOCENAKONCOWAPODPISANA: 'Is mark signed?',
  STUDENT_FORMYZAJEC: 'Meeting Form',
  STUDENT_PRZEDMIOTID: 'Subject ID',
  STUDENT_PRZEDMIOTKOD: 'Subject Code',
  STUDENT_PRZEDMIOTDATA: 'Issue date',
  STUDENT_CZYOCENARECZNA: 'Mark signed manually',
  GRUPA_DZIEKANSKA: "Dean's group",
  ACTIVITY_NUMBER: 'Activity number',
  ATTENDANCE_LIST: 'Attendance list',
  STUDENTS_LIST: 'Student list',
  STUDENTS_LIST_WITH_MARKS: 'Mark list',

  // Karty przedmiotów
  PRZEDMIOT_ID: 'Subject Id',
  PRZEDMIOT_KOD: 'Subject Code',
  PRZEDMIOT_NAZWA: 'Subject name',
  PRZEDMIOT_NAZWA_DLUGA: 'Full subject name',
  KIEROWNIK_PRZEDMIOTU_ID: 'Supervisor Id',
  KIERUNEK_NAZWA: 'Field of study',
  POZIOM_STUDIOW: 'Degree level',
  CZY_WYMAGA_FORM_ZAJEC: 'Does subject require meeting forms?',
  CZY_SPAROWANO_EFEKTY: 'Have effects been paired?',
  CZY_WERSJA_2019: 'Version 2019',
  CZY_WERSJA_2020: 'Version 2020',
  WERSJA: 'Version',
  PUNKTY_ECTS: 'ECTS Points',
  JEZYK_PROWADZENIA: 'Language',
  NAZWA_POLSKA: 'Polish title',
  NAZWA_ANGIELSKA: 'English title',
  NAZWA_FRANCUSKA: 'French title',
  NAZWA_W_JEZYKU_PROWADZENIA: 'Origin language',
  JEDNOSTKA_PROWADZACA: 'Unit',
  WYMAGANIA_WSTEPNE: 'Preliminary requirements',
  METODY_WERYFIKACJI: 'Verification methods',
  WARUNKI_ZALICZENIA: 'Passing requirements',
  SZCZEGULOWE_TRESCI_PRZEDMIOTU: 'Subjects detail contents',
  UWAGI: 'Comments',
  DATA_AKTUALIZACJI: 'Last update in SID',
  JEZYK_KARTY: 'Card language',
  SUBJECT_CARD_EMPTY_CARD_NO_VERSIONS_TITLE: 'Cannot open the card',
  SUBJECT_CARD_EMPTY_CARD_NO_VERSIONS_BODY: 'Card has no versions',
  FILTER_NAME_WKD: 'Displayed subjects cards',
  WKD_MY_SUBJECTS: 'My subjects cards',
  WKD_WKD_SUBJECTS: 'Subjects cards from WKD',

  // Zakładka pojedynczego przedmiotu
  SUBJECTPAGE_TAB_STUDENTS: 'Students',
  SUBJECTPAGE_TAB_GROUPS: 'Groups',
  PRZYDZIAL_LIST_CZYOCENAKONCOWAPODPISANA: 'Is mark signed?',
  PRZYDZIAL_LIST_OCENAKONCOWA: 'Final mark',
  PRZYDZIAL_LIST_KIERUNEKID: 'Field of Study',
  PRZYDZIAL_LIST_STUDENTWYDZIAL: 'Student Faculty',
  PRZYDZIAL_LIST_STUDENTALBUM: 'Register No.',
  STUDENT_OCENYCZASTKOWE: 'Partial marks',
  PRZYDZIAL_LIST_GRUPADZIEKANSKA: "Dean's group",

  // Zakładka karty przedmiotu
  BUTTON_COPY_DATA_FROM_OTHER_CARD: 'Copy data from other card',
  BUTTON_PAIR_EFFECTS: 'Pair effects',
  BUTTON_SAVE_CARD_IN_SID: 'Save card in SID',
  BUTTON_SAVE_CARD_IN_SID_POPCONFIRM:
    'Are you sure you want to save the card in the SID? \n The card will be saved in the SID and published on "programy.p.lodz.pl".',
  BUTTON_EDIT_ON: 'Open edit mode',
  BUTTON_SAVE: 'Save',
  BUTTON_PRINT_CARD: 'Print card',
  BUTTON_GET_CARD_FROM_SID: 'Get card from SID',

  BUTTON_GET_CARD_FROM_SID_POPCONFIRM_IN_EDIT:
    'Are you sure you want to discard the changes you made? \n The changes will be lost. The latest card from the SID will be downloaded.',
  BUTTON_GET_CARD_FROM_SID_POPCONFIRM_NOT_IN_EDIT:
    'Are you sure you want to download the card from the SID? \n The data will not be lost. The card is not in edit mode.',
  BUTTON_GET_CARD_FROM_SID_SUCCESS: 'SID card have been successfully downloaded',

  // domyślne tłumaczenia dla typów zakładek
  'strona-przedmiotu': 'Subject Page',
  'karta-przedmiotu': 'Subject Card',
  'strona-studenta': 'Student Page',

  // modal wyboru nauczyciela w celu przelogowania
  SUPERTEACHER_MODAL_SELECT_A_TEACHER: 'Select a teacher',
  SUPERTEACHER_MODAL_LOGIN_AS: 'Login as',
  SUPERTEACHER_MODAL_LOGOUT_ERROR_TITLE: 'Something went wrong',
  SUPERTEACHER_MODAL_LOGOUT_ERROR_BODY: 'You will be logged out',
  SUPERTEACHER_MODAL_SUBSTITUTE: 'You will act as a substitue for',
  SUPERTEACHER_MODAL_CONFIRM: 'Confirm and login',
  SUPERTEACHER_MODAL_LOG_AS_SUCCESS_TITLE: 'Logged in as another user',
  SUPERTEACHER_MODAL_LOG_AS_SUCCESS_BODY: 'Current you are logged as ',
  SUPERTEACHER_MODAL_LOGOUT_SUCCESS_TITLE: 'Logged out from another user account',
  SUPERTEACHER_MODAL_LOGOUT_SUCCESS_BODY: 'Current you are logged as ',
  SUPERTEACHER_MODAL_LOGOUT_ERROR_SESSION_TEACHER_ACTIVE_TITLE: 'Login as teacher failed',
  SUPERTEACHER_MODAL_LOGOUT_ERROR_SESSION_TEACHER_ACTIVE_BODY: 'Choosen teacher is currently logged in',
  SUPERTEACHER_MODAL_RESOURCES_ACCESS_ERROR_SESSION_TEACHER_ACTIVE_TITLE: 'You will be logged out!',
  SUPERTEACHER_MODAL_RESOURCES_ACCESS_ERROR_SESSION_TEACHER_ACTIVE_BODY: 'Teacher you have been logged in as has active session',

  // Modal generowania raportu
  GENERATE_PROTOCOL_MODAL: 'Report generation',
  GENERATE_PROTOCOL_MODAL_GENERATE_DATE: 'Protocol generation date',
  PROTOCOL_GENERATION_ERROR_NO_STUDENTS_FOR_SUBJECT_TITLE: 'Protocol cannot be generated',
  PROTOCOL_GENERATION_ERROR_NO_STUDENTS_FOR_SUBJECT_DESCRIPTION: 'No students are assigned to the protocol',
  PROTOCOL_GENERATION_ERROR_NO_PROTOCOL_FOR_PARAMETERS_DESCRIPTION: 'No protocol for selected parameters',
  PROTOCOL_GENERATION_ERROR_USER_NOT_AUTHORIZED: 'No permission to generate protocol',
  PROTOCOL_GENERATION_OUT_OF_DATE_TITLE: 'Protocol generation date exceeded',
  PROTOCOL_GENERATION_OUT_OF_DATE_DESCRIPTION: 'No protocol generation available, contact Super Teacher for assistance',
  GENERATE_PROTOCOL_MODAL_AVAILABLE_PROTOCOLS: 'Available protocols',
  GENERATE_PROTOCOL_NO_PERMISSION_TO_ANY_SUBJECT: 'You have no permission to generate protocol for selected subjects.',
  GENERATE_PROTOCOL_REMOVED_SUBJECTS_WITH_NO_PERMISSION_TITLE:
    'Protocols will be generated for the items to which you have rights',
  PROTOCOL_GENERATION_HAS_NOT_FINISHED_TITLE: 'Protocol generation in progress',
  PROTOCOL_GENERATION_HAS_NOT_FINISHED_DESCRIPTION: 'Currently generating protocols, try again later',
  PROTOCOL_DATABASE_ERROR_TITLE: 'Database error',
  PROTOCOL_DATABASE_ERROR_DESCRIPTION:
    'An error occurred while generating the protocol, please try again or contact your system administrator',
  PROTOCOL_GENERATE_ERROR_TITLE: 'Generating protocol error',
  PROTOCOL_GENERATE_ERROR_DESCRIPTION:
    'An error occurred while generating the protocol, please try again or contact your system administrator',
  PROTOCOL_NOT_GENERATED_MODAL: 'One or more protocols were not generated',
  PROTOCOL_NOT_GENERATED_UNKNOWN: 'The protocol was not generated, contact your system administrator',
  PROTOCOL_NOT_GENERATED_NO_SIGN_MARKS: 'The protocol was not generated, because one or more of the final marks are unsigned',
  PROTOCOL_NOT_GENERATED_UNKNOWN_ERROR_INFO: 'Generation failure',
  PROTOCOL_NOT_GENERATED_NO_SIGN_MARKS_ERROR_INFO: 'Lack of signature',

  //Oceny
  PICK_MARK: 'Select',

  // modal podpisywania ocen
  SIGN_MARKS_MODAL_TITLE: 'Marks signing',
  SIGN_MARKS_MODAL_CONFIRM: 'Sign',
  SIGN_MARKS_MODAL_ARE_YOU_SURE: 'Are you sure to cancel marks signing process?',
  SIGN_MARKS_MODAL_MISSING_FINAL_MARK: 'At least one of the picked students has no final mark!',
  SIGN_MARKS_MODAL_ERROR: 'Marks singning process error',
  SIGN_MARKS_MODAL_ERROR_TITLE: 'Signing marks error occured.',
  SIGN_MARKS_MODAL_ERROR_BODY: 'Process has been canceled and marks have NOT been signed.',
  SIGN_MARKS_MODAL_SUCCESS_TITLE: 'Marks have been signed',
  SIGN_MARKS_MODAL_SUCCESS_BODY: 'Marks signing has been processed succesfully.',
  SIGN_MARKS_MODAL_REMOVED_STUDENTS_1:
    'You can only sign grades for students with a final grade you have assigned. Signing grades is possible for ',
  SIGN_MARKS_MODAL_REMOVED_STUDENTS_3: 'selected students.',
  SIGN_MARKS_MODAL_NO_STUDENTS_WITH_FINAL_MARK:
    'Selected students do not have a final grade posted or not posted by you. No grades to sign.',
  SIGN_MARKS_MODAL_INCORRECT_VALUE: 'Input contains not-allowed signs.',
  SIGN_MARKS_MODAL_INCORRECT_LENGTH: 'Please insert 6 signs',

  // modal sms/email
  INPUT_CODE_SMS_TITLE_MODAL: 'Insert SMS code',
  INPUT_CODE_EMAIL_TITLE_MODAL: 'Insert EMAIL code',
  SMS_CODE_EXPIRED_TITLE: 'SMS code expired',
  SMS_CODE_EXPIRED_BODY: 'Try the assessment signing process again',

  //modal wyboru pracownika
  EMPLOYEE_CONFIRM__MODAL_TITLE: 'Choose an employee to authentication',
  EMPLOYEE_CONFIRM__MODAL_SELECT_A_EMPLOYEE: 'Choose an employee',
  EMPLOYEE_CONFIRM__MODAL_START_TYPING_PLACEHOLDER: 'Choose an employee',
  SIGN_MARK_WRONG_IP_RANGE_TITLE: 'Marks singning process error',
  SIGN_MARK_WRONG_IP_RANGE_BODY:
    'To sign an evaluation you must register your phone number, which will receive a text message authorizing this operation. If you do not have a registered phone number, please go to the Deans Office to sign your grades.',
  SIGN_MARK_INVALID_MARK_IMPORTANCE_TITLE: 'Incorrect grade importance',
  SIGN_MARK_INVALID_MARK_IMPORTANCE_BODY: "Report the necessity of update grade importance to dean's office",

  //modalu kodu email pracownika
  INPUT_CODE_EMAIL_EMPLOYEE_TITLE_MODAL: 'Enter the code sent to the email of the employee you selected in the previous step',

  //modal z loaderem
  MARKS_SIGNING_IN_PROGRESS: 'Marks signing in progress...',

  // Modal parowania efektów
  PAIR_EFFECTS_MODAL: 'Effects pairing',
  PAIR_EFFECTS_MODAL_CHOOSE_STUDY_PROGRAM: 'Study program choice',
  PAIR_EFFECTS_MODAL_LEARNING_OUTCOMES: 'Learning outcomes',
  PAIR_EFFECTS_MODAL_EFFECT_DESCRIPTION: 'Effect description',
  PAIR_EFFECTS_MODAL_EFFECT_CODE: 'Effect code',
  PAIR_EFFECTS_MODAL_CHOOSE_CARD_LANG: 'Card lagnguage choice',
  PAIR_EFFECTS_MODAL_CHOOSE_CARD_VERSION: 'Card version choice',
  PAIR_EFFECTS_SUCCESS_TITLE: 'Learning effects have been saved.',
  PAIR_EFFECTS_SUCCESS_DESCRIPTION: 'To publish leaarning effects in SID, click on "Save Card in SID" button.',
  PAIR_EFFECTS_MODAL_AVAILABLE_EFFECTS: 'Available learning effects',
  PAIR_EFFECTS_MODAL_EFFECTS_TO_BE_PAIRED: 'Paired learning effects',
  PAIR_EFFECTS_MODAL_ITEM: 'item',
  PAIR_EFFECTS_MODAL_ITEMS: 'items',

  // modal historii zmian
  CHANGELOG_MODAL_TITLE: 'Change Log',
  CHANGELOG_MODAL_SEARCH: 'Search',

  // modal Realizatorzy Przedmiotu
  REALIZATORZY_MODAL_LIST: 'Course Instructor List',
  REALIZATORZY_MODAL_CHOOSE: 'Select realizers from the list',
  //KARTA PRZEDMIOTU
  SELECT_FORM_VERSION: 'Select form version',
  KP_LICZBA_PUNKTOW_ECTS: 'ECTS Points',
  KP_NAZWA_W_JEZYKU_PROWADZENIA: 'Origin Name',
  KP_NAZWA_PL: 'Name (PL)',
  KP_NAZWA_EN: 'Name (EN)',
  KP_JEZYK_ZAJEC: 'Subject language',
  KP_JEDNOSTKA_PROWADZACA: 'Unit',
  KP_FORMY_ZAJEC_LICZBA_GODZIN: 'Classes Forms & Hours Amount',
  KP_KIEROWNIK_PRZEDMIOTU: 'Subject Supervisor',
  KP_REALIZATORZY_PRZEDMIOTU: 'Course Instructors',
  KP_WYMAGANIA_WSTEPNE: 'Preliminary Requirements',
  KP_WYMAGANIA_WSTEPNE_EN: 'Preliminary Requirements (EN)',
  KP_TRESCI_PROGRAMOWE: 'Program Content',
  KP_TRESCI_PROGRAMOWE_EN: 'Program Content (EN)',
  KP_EFEKTY_UCZENIA: 'Learning Effects',
  KP_EFEKTY_UCZENIA_EN: 'Learning Effects (EN)',
  KP_METODY_WERYFIKACJI: 'Verification Methods',
  KP_METODY_WERYFIKACJI_EN: 'Verification Methods (EN)',
  KP_FORMY_WARUNKI_ZAL: 'Forms and Passing requirements',
  KP_FORMY_WARUNKI_ZAL_EN: 'Forms and Passing requirements (EN)',
  KP_SZCZEGOLOWE_TRESCI: 'Subject Detailed Content',
  KP_SZCZEGOLOWE_TRESCI_EN: 'Subject Detailed Content (EN)',
  KP_LITERATURA: 'Literature',
  KP_LITERATURA_UZUPELNIAJACA: 'Complementary Literature',
  KP_UWAGI_WLASNE_PUBLIKOWANE: 'Published comments',
  KP_UWAGI_WLASNE_PUBLIKOWANE_EN: 'Published comments (EN)',
  KP_UWAGI_WLASNE_PRYWATNE: 'Private Comments',
  KP_UWAGI_WLASNE_PRYWATNE_EN: 'Private Comments (EN)',
  KP_DATA_AKTUALIZACJI: 'Last Update Date',
  KP_DATA_PUBLIKACJI: 'Last Publication Date',
  KP_DATA_OST_MODYFIKACJI: 'Last Update Date',
  KP_DATA_POBRANIA_Z_SID: 'Last Download From SID Date',
  SUBJECT_CARD_NO_AVAILABLE_VERSIONS: 'No available forms',
  SUBJECT_CARD_ARE_EFFECTS_PAIRED: 'Learning effects paired',
  SUBJECT_CARD_IS_IN_EDIT: 'The subject card is in the edition',
  SUBJECT_CARD_IS_IN_EDIT_TOOLTIP:
    'You are currently working on a local copy of the card and the information in it may not match the card in SID. To exit edit mode, publish the card using the "Save Card in SID" button or get the latest card from SID using the "Get Card from SID" button.',
  UNSUPPORTED_DATA_FORMAT: 'Unsupported data format',
  KP_KOD_PRZEDMIOTU: 'Subject code',
  KP_CAN_NOT_SIGNING_STUDENT_MARKS: 'Mark at least one student to sign the evaluation',
  KP_CAN_NOT_SIGNING_STUDENT_MARKS_FINAL_MARK: 'Mark at least one student for a final grade',
  KP_CAN_NOT_SIGNING_NO_ACCESS: 'No access',
  SUBJECT_CARD_PRINT_HEADER: 'Subject card',
  KP_FORMY_ZAJEC_EMPTY:
    "Without the forms of courses entered, the course card is locked for editing. Please report the completed forms to the Dean's Office.",

  BEFORE_CHANGE: 'Before Change',
  TABLE_HEADER_DESCRIPTION: 'Description',
  TABLE_HEADER_FIRSTNAME: 'First name',
  TABLE_HEADER_LASTNAME: 'Last name',
  HOURS_AMOUNT: 'Hours.',
  ADD_NEW_RECORD: 'Add new record',
  ADD_NEW__PREDEFINED_RECORD: 'Add predefined record',
  TOTAL: 'Total',
  FORMY_ZAJEC_NAZWA: 'Class form',
  FORMY_ZAJEC_GODZ_KONT: 'Hours Amount',
  FORMY_ZAJEC_E_LEARNING: 'e-learning',
  FORMY_ZAJEC_UDZIAL_WAGOWY: 'Class forms importance (%)',
  FORMY_ZAJEC_INFO_SUMA_WAG_ROWNA_100: 'Classess forms importance sum have to be equal 100%',
  BILANS_OPIS: 'Description (PL)',
  BILANS_OPIS_EN: 'Description (EN)',
  BILANS_GODZ: 'Hours Bilance',
  PREDEFINED_TABLE_CHOOSE_VALUE: 'Select value from dropdown list',
  KP_BILANS_GODZIN: 'Hours balance',
  CANNOT_EDIT_RECORD: 'Record cannot be edited.',

  //modal kopiowania karty przedmiotu
  COPY_SUBJECT_CARD_MODAL_TITLE: 'Copy subject card',
  COPY_SUBJECT_CARD_MODAL_SELECT: 'Select card',
  COPY_SUBJECT_CARD_MODAL_SELECTED_CARD: 'Selected card',
  COPY_CARD_SUCCESS_TITLE: 'Success',
  COPY_CARD_SUCCESS_DESCRIPTION: 'Copying Subject Card succedd',
  COPY_CARD_POPCONFIRM_TEXT:
    'Are you sure you want to copy data from another card? \n The card will be saved in the SID and published on "programy.p.lodz.pl".',

  // modal przepisywania ocen końcowych na podstawie ocen wyliczonych
  COPY_FINAL_MARKS_MODAL_TITLE: 'Copy final marks based on calculated ones',
  COPY_FINAL_MARKS_REMOVED_STUDENTS_ALERT_TITLE: 'Among selected students:',
  COPY_FINAL_MARKS_REMOVED_STUDENTS_ALERT_TITLE_ERROR: '{{howMuch}} out of {{from}} marks were correctly given',
  COPY_FINAL_MARKS_REMOVED_STUDENTS_ALERT_DESCRIPTION_NO_CALCULATED_MARK: 'have no partial marks signed',
  COPY_FINAL_MARKS_REMOVED_STUDENTS_ALERT_DESCRIPTION_MANUALLY_SIGNED_MARK: 'have final mark signed manually',
  COPY_FINAL_MARKS_BY_ANOTHER:
    'has a final grade issued by another instructor, it will be overwritten and any signature canceled',
  COPY_FINAL_MARKS_REMOVED_STUDENTS_ALERT_DESCRIPTION: 'Final marks would be copied for the following students:',
  COPY_FINAL_MARKS_REMOVED_STUDENTS_ALERT_DESCRIPTION_ERROR:
    'For the students listed below, the grade could not be given. Please check the correctness of the data and try again or contact your system administrator. Report number: {{hash}}',

  // zapis w SID
  SAVE_IN_SID_UPDATE_CANCELLED: 'Subject card update to SID has been held back',
  SUBJECT_CARD_SAVE_TO_SID_SUCCESS_TITLE: 'Subject card has been successfully published.',
  SUBJECT_CARD_PUBLISH_LEARNING_EFFECTS_SUCCESS_TITLE: 'Learning efffects have been successfully published.',
  SUBJECT_CARDS_SAVE_SID_ERROR_NO_EFEKTY_KIERUNKOWE_TITLE: 'No learning effects',
  SUBJECT_CARDS_SAVE_SID_ERROR_NO_EFEKTY_KIERUNKOWE_DESCRIPTION: 'Add learning effects before publishing subject card in SID',

  CANNOT_GET_SUBJECT_INFO: 'Error occured on getting subject data',

  //proces wystawiania ocen
  UPDATE_MARK_CUSTOM_MESSAGE_TITLE: 'Mark update failed',
  DATE_NOT_AVAILABLE: 'Date is unavailable',

  // przepisanie ocen końcowych na podstawie ocen końcowych
  COPY_FINAL_MARKS_NO_CALCULATED_MARKS_TITLE: 'Marks cannot be copied for selected students',
  COPY_FINAL_MARKS_NO_CALCULATED_MARKS_DESCRIPTION:
    'Selected students have manually signed final mark or have no calculated mark.',

  // zaznaczenie wszystkich rekordów na liście
  SELECT_ALL_RECORDS_IN_TABLE_INFO: 'Displayed records are selected',
  SELECT_ALL_RECORDS_IN_TABLE_BUTTON: 'Select all',
  SELECT_ALL_SUBJECTS: 'Select all subjects',
  DESELECT_ALL_SUBJECTS: 'Deselect all subjects',

  //klucze pól
  semestrAkademicki: 'Semester',
  rokAkademicki: 'Year',
  przedmiotKod: 'Subject code',
  wydzialZlecajacyNazwa: 'Commissioning Faculty',
  przedmiotNazwa: 'Subject name',

  //błędy bazy danych
  DATABASE_ERROR_TITLE: 'Database error',
  DATABASE_ERROR_BODY_1: 'Please contact system administrator',
  DATABASE_ERROR_BODY_2: 'Report number: ',

  // pobieranie pliku .csv
  GET_LIST_ERROR_NO_DATA: 'No data for subject.',

  //cache
  DATA_SYNC_IN_PROGRESS: 'Data sync in progress...',
  DATA_SYNC_UP_TO_DATE: 'Data is up-to-date',
  DATA_SYNC_REFRESH_PAGE: 'Refresh page to get the newest data',
  DATA_SYNC_FAIL: 'Data sync fail',
  DATA_SYNC_FAIL_DESCRIPTION: 'Data you are working on may be out-of-date, application will try to sync data after its restart',

  ///maintenance mode
  MAINTENANCE_MODE_END_DATE: 'Scheduled time of completion',
  MAINTENANCE_MODE_PAGE_BOK_INFO: 'For urgent matters, please consult Customer Service',
  MAINTENANCE_MODE_PAGE_BOK_TITLE: 'Customer Service',
  MAINTENANCE_MODE_PAGE_BOK_CONTACT: 'tel. 42 631 28 99',
  MAINTENANCE_MODE_PAGE_BOK_CONTACT_NET: '(from network TUL 2899)',
  MAINTENANCE_MODE_PAGE_BOK_EMAIL: 'bok@p.lodz.pl',

  // Not Found
  NO_ACCESS_TITLE: 'Cannot get resource.',
  NO_ACCESS_SUBTITLE: 'Data you are trying to get is unavailable. The reason may be: ',
  NO_ACCESS_NO_ACCESS: 'no access to resource',
  NO_ACCESS_NOT_FOUND: 'no resource in database',
  NO_ACCESS_UNKNOWN_ERROR: 'temporary technical problem with getting data',

  //nowe kody błędów
  TYPICAL_ERROR_CODES_ALL_TITLE: 'Wrong request',
  TYPICAL_ERROR_CODES_ALL_SUBTITLE: 'Please contact system administrator',
  WRONG_DATA_TITLE: 'Wrong data',
  WRONG_DATA_SUBTITLE: 'Verify the completed data or contact system administrator',

  //student finder
  SELECT_A_STUDENT: 'Select a student (current semester)',
  STUDENT_FILTER_IMIE_NAZWISKO: 'First name and surname',
  STUDENT_FILTER_ALBUM: 'Register No.',
  STUDENT_FILTER_WYDZIAL: 'Student Faculty',
  STUDENT_FILTER_KIERUNEK: 'Field of Study',
  STUDENT_FILTER_RODZAJ: 'Study type',
  STUDENT_FILTER_GRUPA_DZIEKANSKA: "Dean's group",

  //info o serwerach
  ENVIRONMENT_DEVELOPMENT: 'DEVELOPMENT ENVIRONMENT',
  ENVIRONMENT_STAGE: 'TESTING ENVIRONMENT',

  ///przejdz do panelu admina
  ADMIN_PANEL: 'Administrator panel',

  //notification admin
  NOTIFICATION_ADMIN_TITLE: 'Information and notices',
  NO_SHOW_AGAIN: 'Do not show again',

  //opcje do zaznaczania studentów na stronie przedmiotu
  SELECT_STUDENTS_ALL: 'Select all',
  SELECT_STUDENTS_NONE: 'Deselect all',
  SELECT_STUDENTS_WITHOUT_FINAL_MARK: 'Select students without final mark',
  SELECT_STUDENTS_WITHOUT_FINAL_MARKS_AND_MINE: 'Select students without final mark and \n with final mark given by me',
};
